import React from 'react';
import { Cinnamon } from 'butter-toast';
import ImportProgressContent from "./ImportProgressContent";

function SuccessfulToastContent({
    toastId,
    dismiss,
    fileName,
    large,
    scheme,
    title,
    message,
    showLink,
    history,
    companyId,
  }) {

    return (
      <Cinnamon.Crisp
        toastId={toastId}
        dismiss={dismiss}
        fileName={fileName}
        title={title}
        message={message}
        showLink={showLink}
        history={history}
        companyId={companyId}
        timeout={large ? 20000 : 10000}
        scheme={Cinnamon.Crisp[scheme]}
        content={
          <ImportProgressContent
            toastId={toastId}
            dismiss={dismiss}
            large={large}
            fileName={fileName}
            message={message}
            showLink={showLink}
            history={history}
            companyId={companyId}
          />
        }
      />
    );
  }

  export default SuccessfulToastContent;